@if(currentView === views.Home) {
  <div class="container">
    <button (click)="getGroups(true)" class="request-button">Ver Grupos</button>

    <button (click)="selectView(views.CreatingGroup)" class="request-button">Crear Grupo</button>
  </div>

  <!-- <div class="group-searched-container">
    <div class="group-search-information">
      <p class="text-info">Devuelve un Grupo específico (GET).</p>
      <button (click)="getGroup()">Buscar Grupo</button>
      <div class="name-input-container">
        <input type="text" [(ngModel)]="groupNameToSearch" class="name-input" placeholder="Nombre">
        @if(groupNotFound) {
          <p class="group-not-found">Grupo no encontrado</p>
        }
      </div>
    </div>

    <div class="group-searched">
      @if(!!groupSearched) {
        @if(!!groupSearched.nombre) { <p><strong>Nombre: </strong>{{groupSearched.nombre}}</p>
        @if(!!groupSearched.wsEditorContenidos) { <p><strong>Ws Editor Contenidos: </strong>{{groupSearched.wsEditorContenidos}}</p>
        @if(!!groupSearched.wsNovaSmartPhone) { <p><strong>Ws Nova Smart Phone: </strong>{{groupSearched.wsNovaSmartPhone}}</p>
        @if(!!groupSearched.wsGestion) { <p><strong>Ws Gestion: </strong>{{groupSearched.wsGestion}}</p>
        @if(!!groupSearched.urlEpda) { <p><strong>Url Epda: </strong>{{groupSearched.urlEpda}}</p>
        @if(groupSearched.loginGrupo !== undefined) { <p><strong>Login Grupo: </strong>{{groupSearched.loginGrupo ? 'Si' : 'No'}}</p>
        @if(groupSearched.pruebas !== undefined) { <p><strong>Pruebas: </strong>{{groupSearched.pruebas ? 'Si' : 'No'}}</p>
        @if(!!groupSearched.grupoMaestro) { <p><strong>Grupo Maestro: </strong>{{groupSearched.grupoMaestro}}</p>
        @if(!!groupSearched.aeReferencia) { <p><strong>Ae Referencia: </strong>{{groupSearched.aeReferencia}}</p>
        @if(groupSearched.replicacionContinua !== undefined) { <p><strong>Replicacion Continua: </strong>{{groupSearched.replicacionContinua ? 'Si' : 'No'}}</p>
      }
    </div>
  </div> -->
}

@if(currentView === views.Groups) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="groupToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de Grupos -->
  <div class="scroll-container">
    <div class="groups-container">
      @for(group of groups; track group.nombre ?? $index) {
        <div class="group" (click)="selectView(views.GroupDetails, group)">
          <p>{{group.nombre ? group.nombre : '- -'}}</p>
        </div>
      }
    </div>
  </div>
}

<!-- Vista de detalles, editar o crear Grupo -->
@if(currentView === views.GroupDetails || currentView === views.CreatingGroup || currentView === views.EditingGroup) {
  <div class="edit-group-container">
    <h4>{{currentView === views.GroupDetails ? 'Detalles de Grupo' : (currentView === views.CreatingGroup ? 'Crear Grupo' : 'Editando Grupo con nombre "' + selectedGroup.nombre + '"')}}</h4>

    <div class="input-container">
      <label>Nombre: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.nombre" placeholder="Nombre" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <div class="input-container">
      <label>Url Editor Contenidos: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.wsEditorContenidos" placeholder="WsEditorContenidos" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <div class="input-container">
      <label>Url NovaSmartPhone: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.wsNovaSmartPhone" placeholder="WsNovaSmartPhone" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <div class="input-container">
      <label>Url WsGestion: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.wsGestion" placeholder="WsGestion" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <div class="input-container">
      <label>Url Epda: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.urlEpda" placeholder="UrlEpda" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <div class="input-container">
      <label>Grupo Maestro: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.grupoMaestro" placeholder="GrupoMaestro" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <div class="input-container">
      <label>AE Referencia: </label>
      <input type="text" class="new-input" [(ngModel)]="newGroup.aeReferencia" placeholder="AeReferencia" [readonly]="isReadOnly && currentView !== views.CreatingGroup">
    </div>

    <!-- <div class="checkbox-container">
      <div class="option-checkbox-container">
        <label (click)="currentView === views.EditingGroup || currentView === views.CreatingGroup ? changeActivated('loginGrupo') : ''"
          [ngClass]="{'disabled-label': !booleanGroupValues.loginGrupo.activated}">Login Grupo</label>
        <div class="input-checkbox-container">
          @if(booleanGroupValues.loginGrupo.activated) {
            <input type="checkbox" [(ngModel)]="booleanGroupValues.loginGrupo.value" class="loginGrupo-checkbox" [disabled]="currentView === views.GroupDetails" />
          }
        </div>
      </div>

      <div class="option-checkbox-container">
        <label (click)="currentView === views.EditingGroup || currentView === views.CreatingGroup ? changeActivated('pruebas') : ''"
          [ngClass]="{'disabled-label': !booleanGroupValues.pruebas.activated}">Pruebas</label>
        <div class="input-checkbox-container">
          @if(booleanGroupValues.pruebas.activated) {
            <input type="checkbox" [(ngModel)]="booleanGroupValues.pruebas.value" class="pruebas-checkbox" [disabled]="currentView === views.GroupDetails" />
          }
        </div>
      </div>

      <div class="option-checkbox-container continuous-rep">
        <label (click)="currentView === views.EditingGroup || currentView === views.CreatingGroup ? changeActivated('replicacionContinua') : ''"
          [ngClass]="{'disabled-label': !booleanGroupValues.replicacionContinua.activated}">Replicacion Continua</label>
        <div class="input-checkbox-container">
          @if(booleanGroupValues.replicacionContinua.activated) {
            <input type="checkbox" [(ngModel)]="booleanGroupValues.replicacionContinua.value" class="replicacionContinua-checkbox" [disabled]="currentView === views.GroupDetails" />
        }
        </div>
      </div>
    </div> -->

    <div class="checkbox-container-2">
      <div class="option-checkbox-container-2">
        <label (click)="currentView === views.EditingGroup || currentView === views.CreatingGroup ? changeActivated('loginGrupo') : ''">Login Grupo</label>
        <div class="input-checkbox-container">
          <select [(ngModel)]="newGroup.loginGrupo" [disabled]="currentView === views.GroupDetails">
            <option [ngValue]="undefined">null</option>
            <option [ngValue]="false">False</option>
            <option [ngValue]="true">True</option>
          </select>
        </div>
      </div>

      <div class="option-checkbox-container-2">
        <label (click)="currentView === views.EditingGroup || currentView === views.CreatingGroup ? changeActivated('pruebas') : ''">Pruebas</label>
        <div class="input-checkbox-container">
          <select [(ngModel)]="newGroup.pruebas" [disabled]="currentView === views.GroupDetails">
            <option [ngValue]="undefined">null</option>
            <option [ngValue]="false">False</option>
            <option [ngValue]="true">True</option>
          </select>
        </div>
      </div>

      <div class="option-checkbox-container-2 continuous-rep">
        <label (click)="currentView === views.EditingGroup || currentView === views.CreatingGroup ? changeActivated('replicacionContinua') : ''">Replicacion Continua</label>
        <div class="input-checkbox-container">
          <select [(ngModel)]="newGroup.replicacionContinua" [disabled]="currentView === views.GroupDetails">
            <option [ngValue]="undefined">null</option>
            <option [ngValue]="false">False</option>
            <option [ngValue]="true">True</option>
          </select>
        </div>
      </div>
    </div>

    <div class="legend">
      <button class="active"></button>
      <label>Activo</label>

      <button class="null"></button>
      <label>Nulo</label>
    </div>

    <div class="edit-buttons">
      <button class="button  button-colors"
        (click)="currentView === views.GroupDetails ? selectView(views.Groups) : (currentView === views.CreatingGroup ? selectView(views.Home) : selectView(views.GroupDetails))">
        Volver
      </button>

      @if(currentView === views.GroupDetails) {
        <button class="button  button-colors" (click)="deleteGroup()" [disabled]="!globalService.editing">Eliminar Grupo</button>
      }

      <button class="button  button-colors"
        (click)="currentView === views.GroupDetails ? selectView(views.EditingGroup) : (currentView === views.CreatingGroup ? createGroup() : editGroup())"
        [disabled]="!globalService.editing || !newGroup.nombre || newGroup.nombre.length === 0 || newGroup.nombre === ' '">
        {{currentView === views.GroupDetails ? 'Editar' : 'Confirmar'}}
      </button>
    </div>
  </div>
}